import React, { useState } from "react";

import classes from "./BuyOptions.module.css";
import * as actionCreator from "../../../../Store/actions/index";
import { connect } from "react-redux";

const BuyOptions = (props) => {
  const [inputVal, setInputVal] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  return (
    <form className={classes.BuyOptions}>
      {props.purchaseType === "fast_deal" && (
        <div>
          <input
            type="number"
            placeholder="Discounted Price"
            onChange={(event) => setDiscountedPrice(event.target.value)}
          />
        </div>
      )}
      <div>
        <input
          id="5"
          type="radio"
          name="buyOption"
          value="14"
          onChange={(event) => setInputVal("14")}
        />
        <label htmlFor="5">14 days for 5.00 R.M</label>
      </div>
      <div>
        <input
          id="10"
          type="radio"
          name="buyOption"
          value="30"
          onChange={(event) => setInputVal("30")}
        />
        <label htmlFor="10">30 days for 10.00 R.M</label>
      </div>
      <div>
        <input
          id="15"
          type="radio"
          name="buyOption"
          value="60"
          onChange={(event) => setInputVal("60")}
        />
        <label htmlFor="15">60 days for 15.00 R.M</label>
      </div>
      <div className={classes.BtnGroup}>
        <button
          type="button"
          onClick={(event) => {
            props.buyModeHandler(inputVal);
            if (inputVal.trim() !== "") {
              props.onPurchaseFromPcari(
                props.vehicleType,
                props.purchaseType,
                props.postId,
                inputVal,
                discountedPrice,
                props.postState
              );
            }
          }}
        >
          confirm
        </button>
        <button type="button" onClick={(event) => props.buyModeHandler("1")}>
          cancel
        </button>
      </div>
    </form>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPurchaseFromPcari: (
      vtype,
      purchaseType,
      postId,
      purchaseVal,
      discountedPrice,
      postMode
    ) => {
      dispatch(
        actionCreator.purchaseFromPcari(
          vtype,
          purchaseType,
          postId,
          purchaseVal,
          discountedPrice,
          postMode
        )
      );
    },
  };
};

export default connect(null, mapDispatchToProps)(BuyOptions);
